import { useState, useEffect } from "react";
import { clearSession, getSession } from "./utils/authSession";
import { loadProject } from "./api/ProjectReviewApi";
import Login from "./pages/Login/Login";
import ProjectSetup from "./pages/Project/ProjectSetup";
import UserProjects from "./pages/UserProjects/UserProjects";
import Portal from "./pages/Portal/Portal";
import Header from "./static/Header";
import "./i18n";

export const PAGES = {
  PROJECT: "project",
  LOGIN: "login",
  ASSISTANT: "assistant",
  USER_PROJECTS: "user-projects",
  PORTAL: "portal",
  PROJECT_REVIEW: "project-review"
};

export default function App() {
  const [user, setUser] = useState(getSession());
  const [reviewProject, setReviewProject] = useState(null);
  const [page, setPage] = useState(
    getSession() ? PAGES.PROJECT : PAGES.LOGIN
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const pageParam = params.get("page");

    if (pageParam === "user-projects") {
      setPage(PAGES.USER_PROJECTS);
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    if (pageParam === "portal") {
      setPage(PAGES.PORTAL);
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  function handleLogin(userData) {
    setUser(userData);
    setReviewProject(null);
    setPage(PAGES.PROJECT);
  }

  function handleLogout() {
    clearSession();

    localStorage.removeItem("ai4signs_project_auth");
    localStorage.removeItem("ai4signs_portal_auth");
    localStorage.removeItem("userVerified");
    localStorage.removeItem("localUserEmail");
    localStorage.removeItem("lastUsedEmail");

    setReviewProject(null);
    setUser(null);
    setPage(PAGES.PROJECT);
  }

  function requireAuth() {
    if (!user) {
      setPage(PAGES.LOGIN);
      return false;
    }

    return true;
  }

  async function openProjectRevision(companyId, projectId) {
    const project = await loadProject(
      companyId,
      projectId
    );
    setReviewProject(project);
    setPage(PAGES.PROJECT_REVIEW);
  }

  function renderPage() {
    switch (page) {
      case PAGES.USER_PROJECTS:
        return (
          <UserProjects
            onBack={() => setPage(PAGES.PROJECT)}
            onOpenRevision={openProjectRevision}
            onLogout={handleLogout}
          />
        );

      case PAGES.PORTAL:
        return <Portal
          onOpenRevision={openProjectRevision}
        />;

      case PAGES.LOGIN:
        return <Login onLogin={handleLogin} />;

      case PAGES.PROJECT_REVIEW:
        return (
          <ProjectSetup
            reviewProject={reviewProject}
            onGenerate={requireAuth}
          />
        );

      case PAGES.PROJECT:

        if (!user) {
          return <Login onLogin={handleLogin} />;
        }

        return (
          <ProjectSetup
            key={reviewProject ? "review" : "new"}
            reviewProject={reviewProject}
            onGenerate={requireAuth}
          />
        );

      default:
        return <Login onLogin={handleLogin} />;
    }
  }


  return (
    <div className="app-container">
      <Header
        onLogout={handleLogout}
        onPortal={() => {
          setPage(PAGES.PORTAL);
          window.history.pushState({}, "", "?page=portal");
        }}
        onProjects={() => {
          setPage(PAGES.USER_PROJECTS);
          window.history.pushState({}, "", "?page=user-projects");
        }}
        onBack={
          page !== PAGES.PROJECT
            ? () => {
              setReviewProject(null);
              setPage(PAGES.PROJECT);
            }
            : null
        }
      />
      {renderPage()}
    </div>
  );
}
